import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const OAuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { session, setSession } = useAuth();
  const [status, setStatus] = useState("Completing sign-in...");

  const readHashSession = () => {
    const hash = location.hash?.startsWith("#") ? location.hash.slice(1) : location.hash;
    if (!hash) return null;

    const params = new URLSearchParams(hash);
    const accessToken = params.get("access_token");
    if (!accessToken) return null;

    return {
      access_token: accessToken,
      refresh_token: params.get("refresh_token") || null,
      expires_at: params.get("expires_at") ? Number(params.get("expires_at")) : null,
      expires_in: params.get("expires_in") ? Number(params.get("expires_in")) : null,
      token_type: params.get("token_type") || "bearer",
      type: params.get("type") || null,
      user: params.get("email")
        ? {
            email: params.get("email"),
            id: params.get("user_id") || params.get("sub") || null,
          }
        : null,
    };
  };

  useEffect(() => {
    const hashSession = readHashSession();

    if (hashSession?.access_token) {
      setSession(hashSession);
      setStatus("Sign-in complete");
      navigate(hashSession.type === "signup" ? "/setup" : "/dashboard", {
        replace: true,
      });
      return;
    }

    if (session?.access_token) {
      navigate("/dashboard");
      return;
    }

    const token = localStorage.getItem("access_token");
    if (token) {
      navigate("/dashboard");
      return;
    }

    navigate("/login");
  }, [location.hash, navigate, readHashSession, session, setSession]);

  return <div>{status}</div>;
};

export default OAuthCallback;
